import MomentUtils from '@date-io/moment';
import FuseAuthorization from '@fuse/core/FuseAuthorization';
import FuseLayout from '@fuse/core/FuseLayout';
import FuseTheme from '@fuse/core/FuseTheme';
import history from '@history';
import { createGenerateClassName, jssPreset, StylesProvider } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { create } from 'jss';
import jssExtend from 'jss-plugin-extend';
import rtl from 'jss-rtl';
import React from 'react';
import Provider from 'react-redux/es/components/Provider';
import { Router } from 'react-router-dom';
import AppContext from './AppContext';
import { Auth } from './auth';
import routes from './fuse-configs/routesConfig';
import fontFontAwesome from './main/design-system/components/icons/fonts/FontAwesome.ttf';
import fontMaterialCommunityIcons from './main/design-system/components/icons/fonts/MaterialCommunityIcons.ttf';
import fontMaterialIcons from './main/design-system/components/icons/fonts/MaterialIcons.ttf';
import store from './store';
import 'moment/locale/fr';

// Generate required css
const iconFontStyles = `@font-face {
  src: url(${fontMaterialIcons}) format("truetype");
  font-family: MaterialIcons;
}

@font-face {
	src: url(${fontMaterialCommunityIcons}) format("truetype");
	font-family: MaterialCommunityIcons;
}

@font-face {
	src: url(${fontFontAwesome}) format("truetype");
	font-family: FontAwesome;
}`;

// Create stylesheet
const style = document.createElement('style');
style.type = 'text/css';
if (style.styleSheet) {
  style.styleSheet.cssText = iconFontStyles;
} else {
  style.appendChild(document.createTextNode(iconFontStyles));
}

// Inject stylesheet
document.head.appendChild(style);

const jss = create({
  ...jssPreset(),
  plugins: [...jssPreset().plugins, jssExtend(), rtl()],
  insertionPoint: document.getElementById('jss-insertion-point'),
});

const generateClassName = createGenerateClassName();

const App = () => {
  return (
    <>
      <AppContext.Provider
        value={{
          routes,
        }}
      >
        <StylesProvider jss={jss} generateClassName={generateClassName}>
          <Provider store={store}>
            <MuiPickersUtilsProvider utils={MomentUtils}>
              <Auth>
                <Router history={history}>
                  <FuseAuthorization>
                    <FuseTheme>
                      <FuseLayout />
                    </FuseTheme>
                  </FuseAuthorization>
                </Router>
              </Auth>
            </MuiPickersUtilsProvider>
          </Provider>
        </StylesProvider>
      </AppContext.Provider>
    </>
  );
};

export default App;
